import { Select } from "antd"
import type { SelectProps } from "antd/lib/select"
import { noop } from "lodash"
import { useEffect, useMemo } from "react"
import { useQuery } from "react-query"
import { getConversionRulesBySourcePrcode } from "services/parametersService"
type ProductConversionRuleInputProps = SelectProps<any> & {
  prcode: string // Required prop for source product code
  onSelected?: (value: any, option: any) => void
  allowclear?: boolean
}

const ProductConversionRuleInput = ({
  prcode,
  onChange = noop,
  onSelected = noop,
  allowclear,
  ...otherProps
}: ProductConversionRuleInputProps) => {
  const { data: conversionRules, isFetching } = useGetConversionRulesBySourcePrcode(prcode)

  const options: SelectProps<any>["options"] = useMemo(() => {
    return conversionRules?.map((rule) => ({
      ...rule,
      label: rule.targetPrcodelabel,
      value: rule.targetPrcode,
    }))
  }, [conversionRules])

  const handleChange = (value: string, option: any) => {
    onChange(value, option)
    onSelected(value, option)
  }

  return (
    <Select
      allowClear={allowclear}
      options={options}
      optionLabelProp="targetPrcodelabel"
      loading={isFetching}
      placeholder="Select target product"
      {...otherProps}
      onChange={handleChange}
    />
  )
}

export default ProductConversionRuleInput

// Custom hook to fetch conversion rules by source product code
export const useGetConversionRulesBySourcePrcode = (sourcePrcode: string) => {
  return useQuery(
    ["getConversionRulesBySourcePrcode", sourcePrcode],
    () => getConversionRulesBySourcePrcode(sourcePrcode).then((res) => res.list || []),
    {
      enabled: !!sourcePrcode, // Only run query if sourcePrcode is provided
    },
  )
}
